"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SITECODE = void 0;
var SITECODE = {
  NORTH_AMERICA: 1,
  ENGLISH_SPEAKING_INTERNATIONAL: 2,
  JAPAN: 3,
  FRENCH_CANADA: 4,
  KOREA: 5,
  TAIWAN: 6,
  SPEED_DATE: 7,
  LAT_AM: 8,
  STIR: 10
};
exports.SITECODE = SITECODE;